import React from "react";

export default function HomePageIntro(props) {
  const { content } = props.data;
  return (
    <div className="home-page-into-section section-gap" name="home-page-into-section" id="home-page-into-section">
      <div className="container">
        <p className="x-large">{content}</p>
      </div>
    </div>
  );
}
